// Share-link utilities. The app is a static SPA with public-read RLS on the
// content tables, so any in-app URL is already a working share link as long
// as the recipient follows it. This module just (a) builds canonical URLs
// for the surfaces we want to share, (b) writes them to clipboard with a
// graceful fallback, and (c) exposes a "shared mode" detector so views can
// optionally render a banner when opened from a share link.
//
// Detection: a `?share=1` query on the hash marks it shared. Cheap, no
// state. We add the param when we copy the link; removing it (browser back/
// edit URL) returns to normal mode.

export function shareUrl(hashPath: string): string {
  // hashPath is e.g. "/topic/foo-bar" or "/cockpit"; we return a full URL
  // the recipient can open. Always include the share marker.
  const base = `${location.origin}/`;
  const sep = hashPath.includes("?") ? "&" : "?";
  return `${base}#${hashPath}${sep}share=1`;
}

export async function copyShareLink(hashPath: string, button?: HTMLButtonElement): Promise<void> {
  const url = shareUrl(hashPath);
  try {
    await navigator.clipboard.writeText(url);
    if (button) {
      const original = button.textContent;
      button.textContent = "Copied ✓";
      setTimeout(() => { if (button) button.textContent = original; }, 1400);
    }
  } catch {
    prompt("Copy this share link:", url);
  }
}

/** True when the current URL has the ?share=1 marker. Re-evaluated each call. */
export function isShared(): boolean {
  const q = location.hash.split("?")[1];
  if (!q) return false;
  return new URLSearchParams(q).get("share") === "1";
}
